import React, { Component } from "react";

// Global Components
import DashedLineBreakHeader from "components/dashedLineBreakHeader/dashedLineBreakHeader";

// Local Components
import RichText from "./components/richText/richText";

class ProjectPreview extends Component {
  render() {
    return (
      <div className="content">
        <a href={`projects/${this.props.project.fields.slug}`}>
          <DashedLineBreakHeader
            title={this.props.project.fields.title}
            first
          />
        </a>
        <RichText richText={this.props.project.fields.information} />
      </div>
    );
  }
}

export default ProjectPreview;
